<app-sub-page class="width-100" navBackRoute="/about">
  <div
    class="flex width-100 column flex-1 scrollable gap-05"
    style="max-width: 800px"
    [style.height]="getContainerHeight()"
  >
    <div class="text-title width-100 flex">Known Issues</div>
    <p-accordion value="0">
      @for (issue of knownIssues; track $index; let last = $last) {
      <p-accordionTab>
        <ng-template pTemplate="header">
          <div class="flex width-100 flex-between" style="margin-right: 1rem">
            <div class="flex align-center flex-1">
              <div>{{ issue.issue }}</div>
            </div>
            @if (issue.isNew) {
            <p-tag severity="warning" value="New!" />
            }
          </div>
        </ng-template>
        <div class="flex column width-100 gap-1">
          <div class="flex column width-100">
            <div style="font-size: 0.9rem; color: var(--text-color-secondary)">{{ issue.description }}</div>
          </div>
        </div>
      </p-accordionTab>
      @if (!last) {
      <div style="border-bottom: 1px solid var(--surface-300)"></div>
      } }
    </p-accordion>
  </div>
</app-sub-page>
